/**
 * @copyright Copyright (c) Open-Xchange GmbH, Germany <info@open-xchange.com>
 * @license AGPL-3.0
 *
 * This code is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with OX App Suite. If not, see <https://www.gnu.org/licenses/agpl-3.0.txt>.
 *
 * Any use of the work other than as authorized under this license or copyright law is prohibited.
 */

import ext from '@/io.ox/core/extensions'
import folderApi from '@/io.ox/core/folder/api'
import mailApi from '@/io.ox/mail/api'
import yell from '@/io.ox/core/yell'
import { Action } from '@/io.ox/backbone/views/actions/util'
import { settings as coreSettings } from '@/io.ox/core/settings'
import { settings as mailSettings } from '@/io.ox/mail/settings'

import gt from 'gettext'

function generate (folder) {
  const id = `io.ox/mail/actions/favoriteCopy/${folder.id}`
  Action(id, {
    collection: 'toplevel && some',
    action (baton) {
      mailApi.copy(baton.data, folder.id).then(function () {
        yell('info',
          gt(
            // #. %1$d is the number of mails
            // #. %2$s: is a folder name
            gt.ngettext('%1$d Mail copied to %2$s',
              '%1$d Mails copied to %2$s',
              baton.data.length),
            baton.data.length, folder.title))
      }, yell)
    }
  })
  return id
}

const favorites = []

async function updateItems () {
  const extensions = ext.point('io.ox/mail/listview/contextmenu').all() || []
  // clear old extensions
  if (favorites.length > 0) {
    const indexOfFavorites = extensions.findIndex(extension => extension.section === 'favorites')
    if (indexOfFavorites > -1) extensions.splice(indexOfFavorites, favorites.length)
  }
  // clear array
  favorites.length = 0
  // get favorites
  const folders = await folderApi.multiple(coreSettings.get('favorites/mail'))
  folders.forEach(function (folder, index) {
    // we need write access
    if (!folderApi.can('write', folder)) return
    // #. %1$s: is a folder name
    favorites.push(['copyFavorite' + index, 'favorites', gt('Copy to %1$s', folder.title), folder])
  })

  if (favorites.length === 0 || !mailSettings.get('favoriteFolderActions/copy', false)) return

  // add extensions
  const startIndex = (extensions[extensions.length - 1]?.index || 0) + 100
  ext.point('io.ox/mail/listview/contextmenu').extend(
    favorites.map(function (item, index) {
      return {
        id: item[0],
        index: startIndex + index * 100,
        title: item[2],
        ref: generate(item[3]),
        section: item[1]
      }
    })
  )
}

coreSettings.on('change:favorites/mail', updateItems)
mailSettings.on('change:favoriteFolderActions/copy', updateItems)

updateItems()
